import { render, staticRenderFns } from "./image-capture-response.vue?vue&type=template&id=884ec154&"
import script from "./image-capture-response.vue?vue&type=script&lang=js&"
export * from "./image-capture-response.vue?vue&type=script&lang=js&"
import style0 from "./image-capture-response.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "image-capture-response.vue"
export default component.exports